import { render, staticRenderFns } from "./DraftCard.vue?vue&type=template&id=e25251b4&scoped=true&"
import script from "./DraftCard.vue?vue&type=script&lang=ts&"
export * from "./DraftCard.vue?vue&type=script&lang=ts&"
import style0 from "./DraftCard.vue?vue&type=style&index=0&id=e25251b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25251b4",
  null
  
)

export default component.exports